import React from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
import Balancer from "@hightouchio/react-wrap-balancer";
export function SelectEmptyState({ children }) {
    const styles = useStyleConfig("SelectEmptyState");
    return (React.createElement(chakra.p, { __css: styles },
        React.createElement(Balancer, { ratio: 0.65 }, children)));
}
